import {Component, AfterViewInit, ViewChild, ElementRef} from '@angular/core';
import {SelectionModel} from '@angular/cdk/collections';
import {MatLegacyTableDataSource as MatTableDataSource} from '@angular/material/legacy-table';
import {MatSort,Sort} from '@angular/material/sort';
import {AdminApi, Site} from '../admin-api';
import {AppLoaderComponent} from '../../shared/app-loader/app-loader.component';
import {Toast} from '../../shared/toast/toast';
import {MatLegacyDialogRef as MatDialogRef} from '@angular/material/legacy-dialog';
import {LoadingButtonComponent} from '../../shared/loading-button/button';

@Component({
   selector: 'app-add-site',
   templateUrl: './add-site.component.html',
   styleUrls: ['./add-site.component.css']
})
export class AddSiteComponent implements AfterViewInit {
   @ViewChild(AppLoaderComponent) loader: AppLoaderComponent;
   @ViewChild('btnSubmit') btnSubmit: LoadingButtonComponent;
   @ViewChild(MatSort) sort: MatSort;
   @ViewChild('e') e: ElementRef;
   displayedColumns = ['select', 'no', 'site_name', 'site_code'];
   selection = new SelectionModel<Site>(true, []);
   dataSource: any;
   listSite: Site[] = [];
   error: string;
   tin: string;

   q: string = "";
   searchFocused: boolean;
   searchResult: string[];
   searchSize = 8;
   private timer: any;
   numOfSearchChar = 1;

   defaultSort: Sort = {active: 'site_name', direction: 'asc'};

   constructor(private api: AdminApi, public toast: Toast, private dialogRef: MatDialogRef<AddSiteComponent>) {
      this.tin = window.localStorage.getItem('tin');
   }

   ngAfterViewInit() {
      setTimeout(() => {
         this.getData();
      }, 0);
   }

   getData() {
      this.loader.show();
      this.api.listAlfrescoSite().subscribe(
         data => {
            this.listSite = data;
            this.listSite.sort((a: any, b: any) => {
               return a.siteName.localeCompare(b.siteName);
            });
            this.dataSource = new MatTableDataSource<Site>(this.listSite);
            this.dataSource.sort = this.sort;
         }, e => {
            this.toast.error(e.message);
         }
      ).add(() => this.loader.hide());
   }

   /** Whether the number of selected elements matches the total number of rows. */
   isAllSelected() {
      const numSelected = this.selection.selected.length;
      const numRows = this.dataSource.data.length;

      if (numSelected > 0) {
         this.btnSubmit.disabled = false;
      } else {
         this.btnSubmit.disabled = true;
      }
      return numSelected === numRows;
   }

   /** Selects all rows if they are not all selected; otherwise clear selection. */
   masterToggle() {
      if (this.isAllSelected()) {
         this.selection.clear();
         this.btnSubmit.disabled = true;
      } else {
         this.dataSource.data.forEach(row => this.selection.select(row));
         this.btnSubmit.disabled = false;
      }
   }

   disableButton(row: any) {
      const numSelected = this.selection.selected.length;
      if (numSelected > 0) {
         this.btnSubmit.disabled = false;
      } else {
         this.btnSubmit.disabled = true;
      }
      return this.selection.isSelected(row);
   }

   addSites() {
      const sites: Site[] = [];
      this.selection.selected.forEach((site) => {
         site.tin = this.tin;
         sites.push(site);
      });
      this.loader.show();
      this.api.addSites(sites).subscribe(
         res => {
            this.toast.success(res);
            this.dialogRef.close(true);
         }, err => {
            this.toast.error(err.message);
            this.btnSubmit.reset();
            this.btnSubmit.disabled = false;
         }
      ).add(() => this.loader.hide());
   }

   sortData(e: any) {
      this.listSite.sort((a: any, b: any) => {
         let comparatorResult = 0;
         switch (e.active) {
           case 'site_name':
            comparatorResult = a.siteName.localeCompare(b.siteName);
            break;
           case 'site_code':
            comparatorResult = a.siteCode.localeCompare(b.siteCode);
            break;
         }
         return comparatorResult * (e.direction == 'asc' ? 1 : -1);
      });
      this.dataSource.data = this.listSite;
   }

   onSearchFocus() {
      this.searchFocused = true;
   }

   onSearchBlur() {
      setTimeout(() => {
         this.searchFocused = false;
      }, 300);
   }

   selectSearchItem(item: any) {
      setTimeout(() => {
         this.searchFocused = false;
      }, 100);
      this.q = item.siteName;
      this.onSearch();
   }

   onSearchChange(input: any) {
      this.searchResult = null;
      if (this.timer) {
         clearTimeout(this.timer);
      }
      const q = input.value.trim();
      if (q.length < this.numOfSearchChar) {
         return;
      }

      this.timer = setTimeout(() => {
         this.timer = null;
         this.api.listAlfrescoSite(this.q.trim()).subscribe(
            data => {
               if (data && data.length > 0) {
                  this.searchResult = data.slice(0,this.searchSize);
               } else {
                  this.searchResult = [];
               }
            }, e => {
               this.toast.error(e.message);
            }
         ).add(() => this.loader.hide());
      }, 300);
   }

   onSearch(): void {
      this.e.nativeElement.blur();
      this.loader.show();
      this.api.listAlfrescoSite(this.q.trim()).subscribe(
         data => {
            this.listSite = data;
            this.sort.active = this.defaultSort.active;
            this.sort.direction = this.defaultSort.direction;
            this.sort.sortChange.emit(this.defaultSort);
            this.sortData({active: this.sort.active, direction: this.sort.direction});
         }, e => {
            this.toast.error(e.message);
         }
      ).add(() => this.loader.hide());
   }
}
